import { Message } from '../../type';
import React, { HTMLProps } from 'react';
import { MyMessage } from './by-side/MyMessage';
import { TheirMessage } from './by-side/TheirMessage';

type MessageItemProps = {
  myMessage: boolean;
  message: Message;
  standalone?: boolean;
};

export const MessageItem = React.forwardRef<
  HTMLLIElement,
  HTMLProps<HTMLLIElement> & MessageItemProps
>((props, ref) => {
  const { myMessage, message, standalone } = props;
  if (myMessage) {
    return (
      <MyMessage
        key={message.guid}
        ref={ref}
        message={message}
        standalone={standalone}
      />
    );
  } else {
    return (
      <TheirMessage
        key={message.guid}
        ref={ref}
        message={message}
        standalone={standalone}
      />
    );
  }
});

MessageItem.displayName = 'MessageItem';
